export function getAllTasks(state) {
  return state.businessData.allTasks;
}

export function getAllBots(state) {
  return (
    state.botList.map(bot => ({
      label: bot,
      value: bot,
    })) || []
  );
}

export function getAllLacts(state) {
  return (
    state.lactList.map(lact => ({
      label: lact,
      value: lact,
    })) || []
  );
}

export function getBusinessData(state) {
  return state.businessData;
}

export function getBusinessDataEditStatus(state) {
  return state.businessDataEdited;
}

export function getBusinessId(state) {
  return state.businessData.generalSettings
    ? state.businessData.generalSettings.id
    : null;
}

export function getAllTeams(state) {
  return state.allTeams;
}

export function getSupportedLanguages(state) {
  return state.supportedLanguages;
}

export function getAllPlatforms(state) {
  return state.allPlatforms;
}

export function getAllClients(state) {
  return state.allClients;
}

export function getAllPartners(state) {
  return Object.keys(state.partnerIdMap).map(key => ({
    value: state.partnerIdMap[key],
    label: state.partnerIdMap[key],
  }));
}

export function getClientsForDeployments(state) {
  return state.deploymentClients;
}

export function getAllErrors(state) {
  const errorsIndexed = {};
  state.businessDataErrors.forEach(error => {
    if (!errorsIndexed[error.page]) errorsIndexed[error.page] = {};
    errorsIndexed[error.page][error.key] = error;
  });

  return errorsIndexed;
}

export function getReversePartnerIdMap(state) {
  const index = state.partnerIdMap;
  return Object.keys(index).reduce(
    (reversedIndex, key) => Object.assign(reversedIndex, { [index[key]]: key }),
    {}
  );
}
